import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { SignIn, SignUp, useUser, useAuth } from "@clerk/clerk-react";
import Footer from "../components/footer";
import Header from "../components/header";

import "../core/core.scss";
import Home from "../pages/home";
import Book from "../pages/book";
import Contact from "../pages/contact";
import About from "../pages/about";
import { services } from "../utils/objects/services-object";
import { ServiceTemplate } from "./service-router";
import ScrollToTop from "../utils/funcs/scroll-to-top";
import CheckoutSuccess from "../pages/checkout-success";
import CheckoutFail from "../pages/checkout-cancel";
import RemedialQuotePage from "../pages/remedial-quote";
import RemedialCheckoutSuccessPage from "../pages/remedial-checkout-success";
import RemedialCheckoutCancelPage from "../pages/remedial-checkout-cancel";
import FreeQuoteSuccess from "../pages/free-quote-success";
import Dashboard from "../components/dashboard/dashboard";
import AdminBookings from "../components/dashboard/admin/all-bookings";
import PendingEICRApprovals from "../components/dashboard/admin/pending-eicr-approvals";
import AdminLayout from "../components/dashboard/admin/admin-layout";
import { useEffect, useState } from "react";
import Bookings from "../components/dashboard/customer/bookings";
import { getRole } from "../utils/funcs/api/get-role";
import Certificates from "../components/dashboard/customer/certificates";
import { getServerURL } from "../utils/funcs/get-serverURL";
import Terms from "../pages/terms";
import ClaimCertificatePage from "../pages/claim-certificate";
import CheckoutPreview from "../pages/checkout-preview";
import { TrackingLayout } from "../analytics/tracking-layout";
import AdsLandingPage from "../pages/ads-landing";

function AppShell({
  isSignedIn,
  user,
  role,
  serverURL,
  editUpdate,
  setEditUpdate,
}: any) {
  const location = useLocation();
  const isAdsLandingPage = location.pathname === "/ads-landing";
  const showHeader = !isAdsLandingPage;
  const showFooter = !isAdsLandingPage;

  return (
    <>
      <ScrollToTop />
      {showHeader && <Header />}
      <main>
        <Routes>
          <Route element={<TrackingLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/book-now" element={<Book />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/terms&conditions" element={<Terms />} />
            <Route path="/checkout-success" element={<CheckoutSuccess />} />
            <Route path="/remedial-quote/:token" element={<RemedialQuotePage />} />
            <Route path="/remedial-checkout-success" element={<RemedialCheckoutSuccessPage />} />
            <Route path="/remedial-checkout-cancelled" element={<RemedialCheckoutCancelPage />} />
            <Route path="/booking-success" element={<FreeQuoteSuccess />} />
            <Route path="/claim-certificate" element={<ClaimCertificatePage />} />
            <Route path="/checkout-preview" element={<CheckoutPreview />} />
            <Route path="/ads-landing" element={<AdsLandingPage />} />

            <Route path="/sign-in/*" element={<SignIn routing="path" path="/sign-in" />} />
            <Route path="/sign-up/*" element={<SignUp routing="path" path="/sign-up" />} />

            <Route path="/dashboard" element={<Dashboard isSignedIn={isSignedIn} user={user} role={role} />} />
            <Route path="/dashboard/admin" element={<AdminLayout user={user} role={role} />} />
            <Route path="/dashboard/admin/bookings" element={<AdminBookings user={user} role={role} />} />
            <Route path="/dashboard/admin/pending-eicr" element={<PendingEICRApprovals user={user} />} />
            <Route path="/dashboard/reports" element={<Certificates user={user} serverURL={serverURL} />} />
            <Route path="/dashboard/bookings" element={<Bookings user={user} serverURL={serverURL} editUpdate={editUpdate} setEditUpdate={setEditUpdate} />} />
            <Route path="/checkout-cancelled" element={<CheckoutFail />} />

            {services.map((service) => (
              <Route
                key={service.id}
                path={`/book-now/${service.slug}`}
                element={<ServiceTemplate service={service} />}
              />
            ))}
          </Route>
        </Routes>
      </main>
      {showFooter && <Footer />}
    </>
  );
}

export default function Router() {
  const { isSignedIn, user } = useUser();
  const { getToken } = useAuth();

  const [editUpdate, setEditUpdate] = useState(false);

  const [role, setRole] = useState("");

  const serverURL = getServerURL();

  useEffect(() => {
    if (isSignedIn) {
      getRole({ getToken, serverURL, setRole });
    }
  }, [isSignedIn, getToken, serverURL]);

  return (
    <BrowserRouter>
      <AppShell
        isSignedIn={isSignedIn}
        user={user}
        role={role}
        serverURL={serverURL}
        editUpdate={editUpdate}
        setEditUpdate={setEditUpdate}
      />
    </BrowserRouter>
  );
}
